import { CountryModel } from './coutry.model';

export class AdressModel {
  constructor(
    public id: number = 46,
    public thirdPartyId: number = null,
    public addressType: string = null,
    public street1: string = null,
    public street2: string = null,
    public street3: string = null,
    public bp: string = null,
    public city: string = null,
    public zipCode: string = null,
    public country: CountryModel = null,
    public tel: string = null,
    public fax: string = null,
    public email: string = null,
    public checked = false,
    public action: string = null
  ) {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
